import React from 'react';
import { Card } from 'react-bootstrap';
import { getEventList } from '../../components';


const EventsCard = ({ title, mudEvents }) => {
    return (
        <Card className={"m-2 score-card-eom-overview"} >
            <Card.Header className={"going-on-header"}>
                <Card.Title>{title} Events</Card.Title>
            </Card.Header>
            <Card.Body>

                {(mudEvents === undefined) || (mudEvents.length === 0)
                    ? <p>There are currently <strong>no</strong> active events in the realm - why not create one! see <a href="/intro/events">here</a> for details!</p>
                    : null}
                {mudEvents.map((event, index) =>
                    <div key={index}>
                        <strong>{event.organiser}</strong> organised the following event in {event.location}
                        <p>{event.event}</p>
                        <p>{event.expires}</p>
                    </div>)}

            </Card.Body>
        </Card>
    );
}

const getEventData = async (setRealmEvents, setFutureEvents) => {
    let data = await getEventList();
    console.log('setRealmEvents' ,setRealmEvents);
    console.log('setFutureEvents' ,setFutureEvents);
    if (data.result) {
        if(setFutureEvents===undefined) {
            setRealmEvents([...data.currentevents, ...data.futureevents]);
        } else {
            setRealmEvents(data.currentevents);
            setFutureEvents(data.futureevents);
        }
    } else {
        setRealmEvents([]);
        if(setFutureEvents!==undefined) 
            setFutureEvents([]);
    }
}

export { EventsCard, getEventData };